export default __webpack_public_path__ + "static/media/learose.f01e806b.jpg";